// ##############################
// // // Variables - Styles that are used on more than one component
// #############################
import { styles } from "@totalsoft/rocket-webapp-components-deprecated";
export default styles;
